/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { ReactNode } from 'react';
import { InventoryAsset } from '../../../types';
import { UpstackInventoryDetails } from './UpstackInventoryDetails';
import { OutsideInventoryDetails } from './OutsideInventoryDetails';

export interface InventoryDetailsProps {
  data: InventoryAsset;
  extraSection?: ReactNode;
}

export function InventoryDetails({ data, extraSection }: InventoryDetailsProps) {
  return (
    <>
      {data.origin ? (
        <UpstackInventoryDetails
          data={data}
          extraSection={extraSection}
        />
      ) : (
        <OutsideInventoryDetails
          asset={data}
          extraSection={extraSection}
        />
      )}
    </>
  );
}
